/**
 * Кога връщащ се потребител „преиграва“ избора си към GTM.
 *
 * ПРОБЛЕМЪТ, който решава: `applyConsent()` прави две неща — ъпдейтва Google Consent
 * Mode и праща `cookie_consent_update` в `dataLayer`. Второто е тригерът на Microsoft
 * Clarity и Meta Pixel, тоест точно двата тежки тага, заради които GTM контейнерът
 * навремето се отлагаше до свободен момент. Откакто снипетът стои в `<head>`,
 * извикването му в mount ефекта ги вкарва обратно в прозореца на hydration-а.
 *
 * Google Consent Mode не зависи от това забавяне — inline скриптът в `<head>` вече е
 * прочел същия запис синхронно, преди контейнера (виж `consentMode.js`). Тук се
 * отлага само повторението, което пуска не-Google таговете.
 *
 * Отнася се САМО за пътя при зареждане. При клик `applyConsent` се вика директно —
 * там редът е задължителен: първо denied към Consent Mode, за да гръмнат revoke
 * таговете, и чак после триенето на бисквитките.
 *
 * Стои извън `CookieConsentContext.js`, защото контекстите в проекта са `.js` с JSX и
 * транформът на Vitest не ги компилира — тук логиката е тестваема.
 */

/** Най-късният момент, ако браузърът така и не намери пауза. */
export const CONSENT_REPLAY_IDLE_TIMEOUT_MS = 2000;

/**
 * Планира `replay` за първия свободен момент на главната нишка.
 *
 * @param {object|null} stored - записаният избор; без него няма какво да се преиграе.
 * @param {(consent: object) => void} replay - обикновено `applyConsent`.
 * @param {number} [timeout] - таван, ако браузърът не намери пауза.
 * @returns {() => void} отказ на планираното (за cleanup на ефекта).
 */
export function scheduleConsentReplay(stored, replay, timeout = CONSENT_REPLAY_IDLE_TIMEOUT_MS) {
  if (!stored || typeof window === 'undefined') {
    return () => {};
  }

  const run = () => replay(stored);

  // `setTimeout` е резервата за браузъри без requestIdleCallback (Safari под 16.4).
  if (typeof window.requestIdleCallback !== 'function') {
    const timerId = window.setTimeout(run, timeout);
    return () => window.clearTimeout(timerId);
  }

  const idleId = window.requestIdleCallback(run, { timeout });
  return () => {
    if (typeof window.cancelIdleCallback === 'function') {
      window.cancelIdleCallback(idleId);
    }
  };
}
